import React, { memo } from 'react';

interface ParticleData {
  id: number;
  x: number;
  y: number;
  size: number;
  opacity: number;
  color: string;
}

interface ParticleRendererProps {
  particles: ParticleData[];
}

// Individual particle component
const Particle = memo(({ particle }: { particle: ParticleData }) => (
  <div
    style={{
      position: 'absolute',
      left: particle.x - particle.size / 2,
      top: particle.y - particle.size / 2,
      width: particle.size,
      height: particle.size,
      borderRadius: '50%',
      background: particle.color,
      opacity: particle.opacity,
      pointerEvents: 'none',
      willChange: 'transform',
      transform: 'translateZ(0)', // Force GPU acceleration
    }}
  />
));

Particle.displayName = 'Particle';

// Main particle renderer
export const ParticleRenderer: React.FC<ParticleRendererProps> = memo(({ particles }) => {
  // Use CSS transform for better performance
  return (
    <div 
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 500,
      }}
    >
      {particles.map((particle) => (
        <Particle key={particle.id} particle={particle} />
      ))}
    </div>
  );
});

ParticleRenderer.displayName = 'ParticleRenderer';